import {
  numberOnly,
  isEmail,
  isPhone,
  moreThanLength,
  lessThanLength,
  betweenLength,
} from '~components/common/forms/UniversalValidations.js'

export const StudentSatisfactionBlueprint = [
  {
    type: 'main',
    all_change: (form_data, change_key) => {
      let result = {};
      if(change_key == 'summer_intern') {
        result.school_intern = [];
        result.start_class = "";
        result.start_semester = "";
        result.end_class = "";
        result.end_semester = "";
      }
      else if(change_key == 'school_intern') {
        result.summer_intern = null;
        result.start_class = "";
        result.start_semester = "";
        result.end_class = "";
        result.end_semester = "";
      }
      else if(['start_class', 'start_semester', 'end_class', 'end_semester'].includes(change_key)) {
        result.summer_intern = null;
        result.school_intern = [];
      }
      if(Object.keys(result).length) return result;
    },
    all_check: (form_data) => {
      let result = {};
      let class_semester = [
        'start_class', 'start_semester', 'end_class', 'end_semester'
      ].filter(key => !form_data[key]);
      if(class_semester.length > 0 && class_semester.length < 4) {
        class_semester.forEach(key => result[key] = "未填寫完整");
      }
      else if(!form_data.summer_intern && !form_data.school_intern.length && !form_data.start_class){
        result.summer_intern = "三項須選一樣填寫";
        result.school_intern = "三項須選一樣填寫";
        result.start_class = "三項須選一樣填寫";
      }
      if(Object.keys(result).length) return result;
    },
  },
  {
    type: 'outer',
    key: 'directions',
    class_name: 'flex_row',
    blocks: [
      {
        type: 'span',
        div: 1,
        text: '校外實習同學 您好：\n本問卷為本校欲瞭解同學在參與校外實習後，對於自我實務技能及就業競爭力的提升或是自我成長是否有所助益，並可提供學校規劃校外實習課程時能更加完備。本問卷僅進行整體分析，不涉及個別資料判別，請同學撥冗詳實填答。 您的寶貴意見將對未來的學弟妹們，能更加順利進行校外實習。',
      },
      {
        type: 'span',
        text: '在此致上謝意！\n敬祝 身體健康，學業進步！',
      },
      {
        type: 'span',
        text: '國立臺灣科技大學 敬啟',
      },
    ],
  },
  /*壹、參與校外實習課程期間*/
  {
    type: 'section_title',
    text: '壹、參與校外實習課程期間',
  },
  {
    key: 'department_id',
    type: 'select',
    div: 3,
    disabled: true,
    label: '就讀系所：',
  },
  {
    key: 'student_account',
    type: 'input',
    div: 3,
    disabled: true,
    required: true,
    label: '學號：',
    max_length: 500,
  },
  {
    key: 'student_name',
    type: 'input',
    div: 3,
    disabled: true,
    required: true,
    label: '姓名：',
    max_length: 500,
  },
  {
    type: 'outer',
    div: 3,
    class_name: ['flex_row', 'flex_wrap'],
    blocks: [
      {
        type: 'label',
        div: 1,
        text: '實習期間：',
      },
      {
        type: 'number',
        key: 'school_year',
        div: 'grow',
        required: true,
        decimal_place: 0,
        placeholder: '學年度',
      },
      {
        type: 'select',
        key: 'semester',
        div: 'grow',
        required: true,
        placeholder: '學期',
        options: ['上學期', '下學期', '暑期'],
        values: ['1', '2', 'H'],
      },
    ],
  },
  {
    type: 'output_button',
    custom_type: 'date',
    key: 'start_time',
    class_name: 'align_self_end',
    div: 3,
    required: true,
    placeholder: '開始時間',
    icon: 'date',
  },
  {
    type: 'output_button',
    custom_type: 'date',
    key: 'end_time',
    class_name: 'align_self_end',
    div: 3,
    required: true,
    placeholder: '結束時間',
    icon: 'date',
  },
  {
    type: 'input',
    key: 'internship',
    div: 2,
    disabled: true,
    required: true,
    label: '實習機構：',
    max_length: 500,
  },
  {
    type: 'input',
    key: 'intern_address',
    div: 2,
    required: true,
    label: '實習地點：',
    max_length: 500,
  },
  /*貳、實習課程分類*/
  {
    type: 'section_title',
    text: '貳、實習課程分類',
  },
  {
    type: 'radio',
    key: 'classified',
    list_style: 'column',
    required: true,
    options: [
      '暑期實習(實習期間320小時以上，實習學分3學分)',
      '學期實習(實習期間4.5個月以上，實習學分3-9學分)',
      '學年實習(實習期間9個月以上)',
      '海外實習(符合學期、學年實習課程條件，且在大陸地區以外之實習機構實習)',
      '專業成長實習',
    ],
    values: [1, 2, 3, 4, 5],
  },
  /*參、您參與實習課程的年級*/
  {
    type: 'section_title',
    text: '參、您參與實習課程的年級',
  },
  {
    type: 'radio',
    key: 'summer_intern',
    label: '(一)暑期實習',
    options: ['一年級升二年級', '二年級升三年級', '三年級升四年級'],
    values: [1, 2, 3],
  },
  {
    type: 'checkbox',
    key: 'school_intern',
    label: '(二)學期實習/學年實習',
    options: ['一年級下學期', '二年級上學期', '二年級下學期', '三年級上學期', '三年級下學期', '四年級上學期', '四年級下學期'],
    values: [1, 2, 3, 4, 5, 6, 7],
  },
  {
    type: 'outer',
    class_name: ['flex_row', 'flex_wrap'],
    blocks: [
      {
        type: 'label',
        div: 1,
        text: '(三)專業成長實習',
      },
      {
        type: 'input',
        key: 'start_class',
        div: 'auto',
        class_name: ['flex_row', 'intern_period'],
        label: '自',
        max_length: 500,
        tail_label: '年級',
      },
      {
        type: 'input',
        key: 'start_semester',
        div: 'auto',
        max_length: 500,
        class_name: ['flex_row', 'intern_period'],
        tail_label: '學期',
      },
      { type: 'label', div: 'auto', text: '~' },
      {
        type: 'input',
        key: 'end_class',
        div: 'auto',
        class_name: ['flex_row', 'intern_period'],
        tail_label: '年級',
        max_length: 500,
      },
      {
        type: 'input',
        key: 'end_semester',
        div: 'auto',
        class_name: ['flex_row', 'intern_period'],
        tail_label: '學期',
        max_length: 500,
      },
    ],
  },
  /*肆、校外實習滿意度調查*/
  {
    type: 'section_title',
    text: '肆、校外實習滿意度調查',
  },
  {
    type: 'radio_table',
    key: 'check',
    options: ['非常同意', '同意', '普通', '不同意', '非常不同意'],
    values: [1, 2, 3, 4, 5],
    items: [
      ['一、行政運作'],
      '1. 我有參加實習前辦理的行前座談會或說明會。',
      '2. 實習前講習或說明會對我有所助益。',
      '3. 實習前學校提供我完善的實習資訊或諮詢管道。',
      '4. 實習前我已瞭解實習時相關的權利及義務。',
      '5. 實習前我瞭解職場倫理與實習契約內容。',
      ['二、課程規劃'],
      '6. 校外實習前,我了解校外實習工作內容。',
      '7. 我所參與的實習機構,符合主修系所專業領域。',
      '8. 我在校所學業技能有助於實習工作中的運用。',
      ['三、報酬與環境'],
      '9. 實習機構有提供我合理的薪資。',
      '10.實習機構提供我專業且安全的實習環境。',
      '11.實習機構有提供我良好的住宿環境(無住宿者免填答)',
      '12.我能夠適德實習機構之實習環境',
      ['四、實習輔導'],
      '13.我清楚知道與學校輔導老師及實習機構輔導老師的聯繫方式。',
      '14.實習機構輔導老師有協助指導我實習上遇到的困難。',
      '15.學校輔導老師曾來訪視我的實習狀況。',
      ['五、校外實習成效'],
      '16.我能夠將學校所學的知識,應用於實習機構現場。',
      '17.實習課程有助於我吸收新知及拓展視野。',
      '18.實習課程有提升我獨立思考及解決問題的能力。',
      '19.實習課程有助於培養我獨立自主、負責的精神。',
      '20.實習課程有助於我建立良好的人際關係。',
      '21.實習課程有助於我培養團隊合作精神。',
      '22.實習課程對我的專業知識有實質幫助。',
      '23.實習課程有助於我了解業界的需求。',
      '24.實習課程有助於我對職場工作態度的瞭解。',
      '25.實習課程對畢業後尋找工作有所幫助。',
      '26.實習課程對我的未來職涯規劃有幫助。',
      '27.未來實習機構如有意聘用我，我會有意願前往任職。',
      '28.對於實習機構整體的滿意度如何。',
      '29.整體而言，校外實習課程對我的學習是有幫助的。',
    ],
    check: (cur_val) => {
      if(cur_val.length == 0) return "必填";
      let not_required = [10];
      for(let i in cur_val) {
        if(not_required.includes(+i)) continue;
        if(cur_val[i] == null) return "必填";
      }
    },
  },
  { type: 'hr', div: 1 },
  { type: 'span', text: '六、其他' },
  {
    type: 'radio_table',
    key: 'other_check',
    required: true,
    label: '提項',
    options: ['有', '無', '不清楚'],
    values: [1, 2, 3],
    items: [
      '30.我知道實習期間，實習機構有幫我辦理勞保。',
      '31.我知道實習期間，實習機構有幫我辦理健保。',
      '32.我知道實習期間，學校有幫我辦理平安保險。',
    ],
  },
  /*伍、校外實習建議*/
  {
    type: 'section_title',
    text: '伍、校外實習建議：',
  },
  {
    type: 'textarea',
    key: 'suggest',
    max_length: 500,
    required: true,
  },
];
